import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { getScheduleDates, shouldPublish } from "../utils/publishUtils";

const SCHEDULE_KEY = "drunkenDragonClosingModal";

const DrunkenDragonClosingModal = () => {
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation("translation");

  useEffect(() => {
    const schedule = getScheduleDates(SCHEDULE_KEY);
    if (shouldPublish(schedule)) {
      setShowModal(true);
    }
  }, []);

  const handleClose = () => {
    setShowModal(false);
  };

  if (!showModal) {
    return null;
  }

  return (
    <StyledModal
      show={showModal}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      aria-labelledby="drunken-dragon-closing-modal-title"
      centered
      className="drunken-dragon-closing-modal"
    >
      <Modal.Header>
        <div className="header-inner">
          <Modal.Title id="drunken-dragon-closing-modal-title">
            {t("drunkenDragonClosingModal.title")}
          </Modal.Title>
          <img
            src="/img/logos/drunken-dragon-top1.svg"
            alt={t("drunkenDragonClosingModal.logoAlt")}
            className="modal-logo"
          />
        </div>
      </Modal.Header>
      <Modal.Body className="light">
        <h2 style={{ fontWeight: 600, fontSize: '1.5rem', marginBottom: '1rem' }}>
          {t("drunkenDragonClosingModal.heading")}
        </h2>
        <ReactMarkdown>{t("drunkenDragonClosingModal.paragraph1")}</ReactMarkdown>
        <ReactMarkdown>{t("drunkenDragonClosingModal.paragraph2")}</ReactMarkdown>
        <ReactMarkdown>{t("drunkenDragonClosingModal.paragraph3")}</ReactMarkdown>
      </Modal.Body>
      <Modal.Footer>
        <a
          className="modal-btn btn-primary-action"
          href={t("drunkenDragonClosingModal.ctaLink")}
          target="_blank"
          rel="noreferrer"
        >
          {t("drunkenDragonClosingModal.cta")}
        </a>
        <button
          type="button"
          className="modal-btn btn-secondary-action"
          onClick={handleClose}
        >
          {t("drunkenDragonClosingModal.close")}
        </button>
      </Modal.Footer>
    </StyledModal>
  );
};

export default DrunkenDragonClosingModal;

const StyledModal = styled(Modal)`
  z-index: 9999 !important;

  .modal-content,
  .modal-header {
    border-radius: 0;
  }

  .modal-header {
    background-color: #b59771;
    padding: 1.25rem 1rem 1rem;
  }

  .header-inner {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }

  .modal-title {
    color: var(--white);
    font-weight: 700;
    margin: 0;
    font-size: 1.2rem;
  }

  .modal-logo {
    max-height: 2.9rem;
    width: auto;
  }

  .modal-body {
    padding-bottom: 0.5rem;

    p {
      margin-bottom: 0.9rem;
      font-size: 0.95rem;
      line-height: 1.5;
    }
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.7rem;
    border-top: 0;
    padding-top: 0.75rem;
  }

  .modal-btn {
    margin: 0;
    border: 2px solid #b59771;
    border-radius: 0;
    font-size: 0.8rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    padding: 0.6rem 0.9rem;
    text-decoration: none;
    cursor: pointer;
    transition: 0.2s ease;
  }

  .btn-primary-action {
    background-color: #b59771;
    color: var(--white);

    &:hover {
      background-color: var(--white);
      color: #b59771;
    }
  }

  .btn-secondary-action {
    background-color: var(--white);
    color: #b59771;

    &:hover {
      background-color: #b59771;
      color: var(--white);
    }
  }

  @media screen and (max-width: 767px) {
    .header-inner {
      align-items: flex-start;
      flex-direction: column;
    }

    .modal-title {
      font-size: 1.05rem;
    }

    .modal-footer {
      justify-content: stretch;
      width: 100%;
    }

    .modal-btn {
      flex: 1;
      text-align: center;
      font-size: 0.75rem;
    }
  }
`;
